const { useEffect, useRef, useContext, useCallback } = require('react');
const PropTypes = require('prop-types');
const { AndesContext } = require('@andes/context');
const useUpdateCurrentLocation = require('./useUpdateCurrentLocation');

const NOTIFICATION_TOPIC = 'navigation-cp-webview';

function useActionToPlatform(
  idForm,
  setErrorsState,
  setShowSpinner,
  { isEmbed, isFlow, isModal, deviceType, webView, propDevice },
) {
  const device = propDevice || useContext(AndesContext).device;
  const currentOs = device.nativeApp?.os?.toLowerCase();
  const [updateData, setUpdateCurrentLocation] = useUpdateCurrentLocation();
  const flagLastScreen = useRef(false);

  /**
   * Workaround to fix Android bug where is not listening NOTIFICATION_TOPIC event at
   * ZipCodePage and CityPage.
   * Date: 2021-08-02
   * Author: @bcalo_meli
   */
  const closeV2Engine = useCallback((data) => {
    const sendClose = () => {
      flagLastScreen.current = true;

      return MobileWebKit.events
        .dispatch('close', { data: {} })
        .then(() => new Promise((resolve) => setTimeout(resolve, 250)));
    };

    // Should use original flow once Event management is fixed on Android Side.
    if (idForm !== 'addressesForm' && currentOs === 'android') {
      return window.MobileWebKit.navigation.pop()
        // Delay event send to allow Android to resubscribe and listen the event.
        .then(() => new Promise((resolve) => setTimeout(resolve, 50)))
        .then(() => window.MobileWebKit.events
          .dispatch(NOTIFICATION_TOPIC, data))
        .then(sendClose);
    }

    return window.MobileWebKit.events
      .dispatch(NOTIFICATION_TOPIC, data)
      .then(sendClose)
      .then(() => MobileWebKit.navigation.pop());
  }, [currentOs, idForm]);

  useEffect(() => {
    let subscriptionID;
    if (window.MobileWebKit && window.MobileWebKit.engine === window.MobileWebKit.Engines.V200) {
      subscriptionID = MobileWebKit.events.subscribe('close', () => {
        if (!flagLastScreen.current) {
          MobileWebKit.navigation.pop({ animated: false });
        }
      });
    }
    return () => {
      if (window.MobileWebKit && window.MobileWebKit.engine === window.MobileWebKit.Engines.V200 && subscriptionID) {
        window.MobileWebKit.events.unsubscribe(subscriptionID);
      }
    };
  }, []);
  useEffect(() => {
    if (updateData) {
      if (updateData.errors) {
        setErrorsState(updateData.errors);
      } else if ((isEmbed && isFlow !== true) || (isModal === true && deviceType === 'desktop')) {
        window.parent.postMessage({ type: 'nav:cp:update' }, '*');
      } else if (webView) {
        /// TODO Webkit 2
        if (window.MobileWebKit && window.MobileWebKit.engine === window.MobileWebKit.Engines.V200) {
          closeV2Engine(updateData);
        } else {
          const form = document.getElementById(idForm);
          form.children.deeplink.value = updateData.deeplink;
          form.submit();
        }
      } else {
        window.location.href = updateData.redirectUrl;
      }
    }
    if (!webView) {
      setShowSpinner(false);
    }
  }, [deviceType, idForm, isEmbed, isFlow, isModal, setErrorsState, setShowSpinner, updateData, webView, closeV2Engine]);
  return { setUpdateCurrentLocation };
}
useActionToPlatform.PropTypes = {
  idForm: PropTypes.string,
  setErrorsState: PropTypes.func,
  setShowSpinner: PropTypes.func,
};

module.exports = useActionToPlatform;
